module.exports = __webpack_public_path__ + "img/198.4d1a3341.jpg";